import { render, staticRenderFns } from "./RunReportIcon.vue?vue&type=template&id=13874acb&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13874acb')) {
      api.createRecord('13874acb', component.options)
    } else {
      api.rerender('13874acb', component.options)
    }
    module.hot.accept("./RunReportIcon.vue?vue&type=template&id=13874acb&functional=true&", function () {
      api.rerender('13874acb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/icons/RunReportIcon.vue"
export default component.exports